/* ============
 * Account Index Page
 * ============
 *
 * Page where the user can view their account information
 */

export default {
  data() {
    return {
      usersCount: '- loading -',
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/account/index/index.js